"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const faImage_1 = require("@fortawesome/pro-regular-svg-icons/faImage");
exports.FileInput = (0, react_1.forwardRef)(({ onChange }, ref) => {
    const inputId = "file-input";
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: inputId, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: faImage_1.faImage, color: "lighten-grey" }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "file", id: inputId, onChange: onChange, accept: "image/png, image/jpeg", ref: ref }, void 0)] }, void 0));
});
const Wrapper = styled_components_1.default.div `
  cursor: pointer;
  position: absolute;
  left: 1rem;
  bottom: 6px;

  input[type="file"] {
    display: none;
  }

  label {
    cursor: pointer;
    font-size: 1.215rem;
    margin-right: ${({ theme }) => theme.spacings.xs} !important;
  }
`;
//# sourceMappingURL=FileInput.js.map